export default {"src":"/_next/static/media/discord_icon_clyde_white_RGB.a5da5625.svg","height":96,"width":127,"blurWidth":0,"blurHeight":0};